import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'and',
  SignUp: 'Anmelden',
  LogIn: 'Einloggen',
  LOGIN: 'EINLOGGEN',
  Close: 'Schließen',
  Ok: 'OK',
  Back: 'Zurück',
  He: 'Er',
  She: 'Sie',
  Him: 'Ihn',
  Her: 'Sie',
  Find: 'Finde',
  Thanks: 'Dankeschön',
  SingUpLanding: 'Zum Finden hier Tippen',
  LogInLanding: 'Schon Mitglied? Hier einloggen',
  TitleLanding: 'Bist du der alten Datingseiten müde?',
  SubTitleLanding:
    'Wir auch! Entdecke ein neues Erlebnis auf ' +
    config.TITLE +
    ' mit Funktionen wie diesen:',
  logInWithApple: 'Mit Apple einloggen',
  mailIsConfirmed:
    'Herzlichen Glückwunsch! Ihr Konto wurde erfolgreich aktiviert. Vielen Dank für die Bestätigung Ihrer E-Mail. Sie können nun vollen Zugriff auf unsere Dienstleistungen genießen.',
  SignUpWithEmail: 'Mit E-Mail anmelden',
  reactivateAccount: 'Konto reaktivieren',
  welcomeBack: 'Willkommen zurück',
  prevYouDeactivYourAcc: 'Zuvor hast du dein Konto deaktiviert',
  doUwantToReacYourAcc: 'Möchtest du dein Konto reaktivieren',
  yesReactivateMyAcc: 'Ja, reaktiviere mein Konto',
  noKeepDeactivated: 'Nein, deaktiviert lassen',
  signUpWithApple: 'Mit Apple anmelden',
  TermsOfService: 'Nutzungs\u00A0of\u00A0bedingungen',
  PrivacyPolicy: 'Datenschutz\richtlinien',
  JoinToday: 'Heute anmelden',
  firstName: 'Vorname',
  yourFirstName: 'Bitte sag mir deinen Vornamen',
  EmailAddress: 'E-Mail-Adresse',
  password: 'Passwort',
  EnterEmailAddress: 'E-Mail-Adresse eingeben',
  EnterPassword: 'Passwort eingeben',
  PleaseEnterValidEmail: 'Bitte gültige E-Mail-Adresse eingeben',
  PleaseEnterPassword: 'Bitte Passwort eingeben',
  LandPageHeader: 'Bereit für ein neues Abenteuer?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' Dating verbindet' +
    config.NICHE_SINGULAR +
    ' Singles suchen nach einer Romanze',
  LandPageLegal: 'Indem du dich einloggst, akzeptierst du unsere',
  LandPageAllDevices: 'Verfügbar auf allen Geräten',
  ForgotYourPassword: 'Passwort vergessen?',
  or: 'oder',
  Save: 'Speichern',
  views: 'Besuche',
  view: 'Besuch',
  ViewedMyProfile: 'Profil angesehen',
  ViewProfile: 'Profil ansehen',
  UnmatchDelete: 'Unmatch / Löschen',
  UnmatchDeleteQuestionMark: 'Unmatch/Löschen?',
  UnmatchDeleteText:
    'Bist du dir sicher, dass du Unmatchen/löschen möchtest? Du wirst keinen Zugriff mehr auf deine Chat-Geschichte haben mit ',
  YesUnmatchDelete: 'Ja, unmatch/lösche',
  IViewed: 'Ich habe betrachtet',
  ViewedMe: 'Hat mich betrachtet',
  LikesMe: 'Mochte mich',
  Mutual: 'Beidseitig',
  MyLikes: 'Meine Likes',
  Chat: 'Chat',
  Flirts: 'Flirts',
  Send: 'Senden',
  typing: 'tippen',
  UpgradeToVIP: 'Zum VIP upgraden',
  TypeAMessageHere: 'Hier eine Nachricht eintippen',
  FeaturesChat: 'Chat',
  SendMessagesToWhoYouWant: 'Sende Nachrichten, an wen du magst',
  SeeWhoIsInterestedInYou: 'Finde heraus, wer an dir interessiert ist',
  SeeWhoIsReallyInterestedInYou:
    'Finde heraus, wer wirklich an dir interessiert ist',
  IncreaseYourChancesWithAFlirt: 'Verbessere deine Chancen mit einem Flirt',
  GetDatesFast: 'Bekomme schnell Dates, indem du Ja oder Nein sagst',
  FeaturesIncluded: 'Funktionen inkludiert',
  Matches: 'Treffer',
  Likes: 'Likes',
  QuickMatch: 'Schnelles Match',
  Search: 'Suchen',
  Favorite: 'Favorit',
  Favorites: 'Favoriten',
  Browse: 'Suchen',
  MyProfile: 'Mein Profil',
  Settings: 'Einstellungen',
  // Logout
  LogoutH1: 'Du hast dich erfolgreich ausgeloggt',
  LogoutP: 'Wir werden dich vermissen...',
  LogoutButton: 'Wieder einloggen',
  // Unsubscribe
  tooManyEmails: 'Zu viele E-Mails',
  enterYourEmailBelowToUnsub: 'Gib unten deine E-Mail ein, um dich abzumelden',
  unsubscribe: 'Abmelden',
  unsubscribeSuccess: 'Erfolgreich abgemeldet',
  youWillNoLongerReceiveAnyEmailFromUs:
    'Du wirst keine E-Mails mehr von uns erhalten',
  unSubByAccident: 'Unabsichtlich abgemeldet',
  reSubHere: 'Hier wieder anmelden',
  helpUsGetBetter: 'Hilf uns dabei, besser zu werden',
  tellUsWhyYouUnSub: 'Sag uns, warum du dich abgemeldet hast',
  resubscribeSuccessful: 'Erfolgreich wieder angemeldet',
  clickHere: 'Klicke hier',
  toGoBackToTheSite: ', um zur Seite zurück zu gehen',
  pleaseSelectOneOfTheReasonsBelow: 'Bitte wähle einen der Gründe unten aus',
  notEnoughUsers: 'Nicht genug User',
  complicatedToUse: 'Kompliziert zu nutzen',
  notEnoughOptions: 'Nicht genügend Optionen',
  betterAlternatives: 'Bessere Alternativen',
  badExperienceWithAnotherUser: 'Schlechte Erfahrung mit einem anderen User',
  technicalIssues: 'Technische Probleme',
  thanksForYourFeedback: 'Vielen Dank für dein Feedback',
  tapHere: 'Hier tippen',
  // Who's online
  WhosOnline: 'Wer ist online',
  Recent: 'Kürzlich',
  ThisWeek: 'Diese Woche',
  MembsWereOnlineRec: 'Mitglieder, die kürzlich online waren',
  MembsWereOnlineWeek: 'Mitglieder, die diese Woche online waren',
  MembsRecWillAppHere: 'Mitglieder, die kürzlich online waren, erscheinen hier',
  MembsThisWeekWillAppHere:
    'Mitglieder, die diese Woche online waren, erscheinen hier',
  // Browse
  BrowseZero: 'Es gibt',
  BrowseZero2: 'Mitglieder',
  BrowseMembersAppear: 'Mitglieder erscheinen hier',
  // Favorites
  MyFavorites: 'Meine Favoriten',
  FavoritedMe: 'Hat mich favorisiert',
  YourFavWillAppHere: 'Deine Favoriten erscheinen hier',
  MembHaveFavU: 'Mitglieder, die dich favorisiert haben',
  MembWhoFavU: 'Mitglieder, die dich favorisiert haben, erscheinen hier',
  NewPasswordSet: 'Neues Passwort gesetzt. Jetzt kannst du dich einloggen.',
  // Password Recovery
  recoveryTittle: 'Passwort-Wiederherstellung',
  recoveryButton: 'Passwort wiederherstellen',
  goBackToLogIn: 'Zurück zum Login',
  recoveryMessage1:
    'Falls wir ein Konto mit dieser E-Mail-Adresse finden, wird eine Passwort-Wiederherstellung verschickt.',
  NewPassword: 'Neues Passwort',
  SetNewPassword: 'Neues Passwort setzen',
  // Info Line
  NotShared: 'Nicht geteilt',
  // Create Account Email Register
  byCreatingYourAccount:
    'Indem ich der Seite beitrete, stimme ich den Nutzungsbedingungen des ',
  alsoAgree:
    'Ich stimme auch zu, Nachrichten, Konto-Updates & besondere Angebote vial Mail zu erhalten',
  picturesDisclaimer:
    'Die Bilder dienen nur illustrativen Zwecken und jede Person, die abgebildet wird, ist ein Model',
  step: 'Schritt',
  // GenderStep
  StepsTitle:
    'Anmelden & Treffen ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' Liebhaber Jetzt!',
  gender: 'Gender',
  startMeeting: 'Jetzt Treffen starten',
  weNeedInfo: 'Wir brauchen nur ein paar Infos',
  iAm: 'Ich bin ein/e:',
  near: 'Nahe:',
  seeking: 'Suche eine/n:',
  next: 'Weiter',
  viewOtherOptions: 'Andere Optionen betrachten',
  // LocationStep
  location: 'Location',
  WhereAreYouLocated: 'Wo hälst du dich auf?',
  WellFindMatchesInYourArea: 'Wir finden Treffer in deiner Umgebung',
  EnterYourCityOrLocation: 'Gib deine Stadt oder Location ein:',
  // AgeStep
  age: 'Alter',
  howOldAreYou: 'Wie alt bist du?',
  enterAgeBelow: 'Gib unten dein Alter ein',
  ageLabel: 'Alter:',
  agePlaceholder: 'Dein Alter',
  ageError: 'Alter muss zwischen < and > liegen',
  EnterYourAge: 'Gib dein Alter ein',
  // UsernameStep
  username: 'Username',
  chooseUsername: 'Wähle einen Usernamen',
  itWillBeYourBio: 'Er wird in deiner Profil-Bio verwendet werden',
  usernamePlaceholder: 'Beispiel: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: 'Wähle einen Usernamen',
  usernameError: 'Dieser Username ist ungültig',
  usernameLabel: 'Username',
  usernameLabelSmall: '(6-14 Zeichen und Nummern)',
  enterYourNewUsername: `Geben Sie Ihren neuen Benutzernamen ein (e.g. ${getCleanUsername(
    config.NICHE_SINGULAR
  )})`,
  lettersAndNumbersOnly: 'Verwenden Sie nur Buchstaben und Zahlen',
  useAtLeastOneLetter: 'Verwenden Sie mindestens einen Buchstaben',
  // EmailStep
  emailPassword: 'E-Mail/Passwort',
  youAreDone: 'Du bist fast fertig...',
  createYourAccount: 'Erstelle unten dein Konto',
  createAccount: 'Konto erstellen',
  emailError: 'Gib eine gültige E-Mail-Adresse ein',
  passwordError: 'Minimale Passwortlänge beträgt 6 Zeichen',
  enterYourPassword: 'Geben Sie Ihr Passwort ein',
  useMinChar: 'Verwenden Sie mindestens 6 Zeichen',
  ageMissingHeadline: 'Altersanfrage',
  EnterYourEmailAddress: 'Gib deine E-Mail ein',
  ChooseAPassword: 'Wähle ein Passwort',
  itWiilBeUsedForLogin: 'Es wird für die Anmeldung verwendet',
  // PasswordStep
  choosePassword: 'Wählen sie ein Passwort',
  // EmailAndPasswordStep
  enterEmailAndPassword:
    'Geben Sie Ihre E-Mail-Adresse ein und wählen Sie ein Passwort',
  // Auto-complete
  EnterYourLocation: 'Gib deine Location ein',
  EnterYourCityOrZipCode: 'Gib unten deine Stadt oder Postleitzahl ein:',
  enterCityOrZip: 'Gib deine stadt oder postleitzahl ein',
  Menu: 'Menü',
  More: 'Mehr',
  // Matches
  noMatchesFound: 'Keine Treffer gefunden',
  wantMoreMatches: 'Möchtest du mehr Treffer?',
  tapButtonBelow:
    'Tippe auf den Button unten, um deine Treffervorlieben zu ändern',
  editMatchPreferences: 'Treffer-Vorlieben bearbeiten',
  // MyLikes
  youHave: 'Du hast',
  increaseYourMatches:
    'Verbessere deine Treffer, indem du auf den "Liken starten"-Button unten klickst',
  startLiking: 'Liken starten',
  // Mutual
  mutualLikes: 'Gegenseitige Likes',
  // LikesMe
  membersHaveLikedYou: 'Mitglieder haben dich geliked',
  // MyViews
  youHaveViewed: 'Du hast betrachtet',
  profiles: 'Profile',
  membersWhoYouViewed: 'Mitglieder, die du betrachet hast, erscheinen hier',
  // ViewedMe
  memberViewedYou: 'Mitglieder haben dich betrachtet',
  memberWhoViewYourProfile:
    'Mitglieder, die dein Profil betrachtet haben, erscheinen hier',
  // Settings
  logout: 'Ausloggen',
  general: 'Allgemein',
  account: 'Konto',
  legal: 'Rechtliches',
  support: 'Support',
  matchPref: 'Treffer-Vorlieben',
  emailPref: 'E-Mail Vorlieben',
  privacyStgs: 'Privatsphäre Einstellungen',
  reactivateVipMbership: 'VIP-Membership reaktivieren',
  youAreVipMember: 'Du bist ein VIP-Mitglied',
  byCancelingYourVip:
    'Indem du deine VIP-Mitgliedschaft kündigst, wirst du, sobald deine aktuelle Mitgliedschaftsvereinbarung endet, keinen Zugriff mehr auf die folgenden Funktionen haben',
  unLimitedMessages: 'Unbegrenzter Nachrichtenversand',
  seeAllPhotos: 'Alle Fotos betrachten',
  unlimtedUndo: 'Uneingeschränktes Rückgängig machen',
  deactivateAccount: 'Konto deaktivieren',
  deleteAccount: 'Konto löschen',
  showMe: 'Mir anzeigen',
  limitSearchToDistance: 'Beschränke Suche auf Entfernung',
  showAges: 'Zeige Alter',
  men: 'Männer',
  women: 'Frauen',
  toastPrefUpdatedSucc: 'Vorlieben erfolgreich aktualisiert',
  receiveEmail: 'E-Mail erhalten',
  whenSomebodySendsNewMsg: 'Wenn mir jemand eine neue Nachricht schickt',
  whenSomebodyLikesMe: 'Wenn mich jemand liked',
  whenSomebodyVisitMyPof: 'Wenn jemand mein Profil besucht',
  whenNewMembersComeOnline: 'Wenn neue Mitglieder online kommen',
  withDiscountPromotions: 'Mit Rabatt-Aktionen',
  whenSomebodyFlirtsMe: 'Wenn jemand mit mir flirtet',
  whenSomebodyAddsMeToFavorites: 'Wenn mich jemand zu Favoriten hinzufügt',
  whenNearbyMembersComeOnline: 'Wenn Mitglieder in der Nähe online kommen',
  withNewWaysToMeetSingles: 'Mit neuen Möglichkeiten, Singles zu treffen',
  whenMyFavoritesComeOnline: 'Wenn meine Favoriten online kommen',
  whenNearbyMembersUploadPhoto:
    'Wenn Mitglieder in der Nähe ein Foto hochladen',
  whenSomebodyMatchesWithMe: 'Wenn jemand mit mir übereinstimmt',
  whenSomebodyTriesToConnectWithMe:
    'Wenn jemand versucht, sich mit mir zu verbinden',
  notifEmailPauseFor30Days:
    'Alle E-Mail-Benachrichtigungen für 30 Tage pausieren',
  notifEmailPausedUntil: 'E-Mail-Benachrichtigungen pausiert bis',
  notifOptions: 'Benachrichtigungsoptionen',
  notifUpdateSucc: 'Benachrichtigungen erfolgreich aktualisiert',
  privacySettingsText1: 'Kontrolliere wer dein Profil sieht',
  privacySettingsText2: 'Wähle unten eine oder mehrere Optionen',
  importantNotice: 'Wichtiger Hinweis',
  byDeactivatingYourAccount:
    'Indem du dein Konto deaktivierst, wirst du keinen Zugriff mehr auf Folgendes haben, bis du dein Konto reaktivierst',
  yourMatches: 'Deine Treffer',
  yourMessages: 'Deine Nachrichten',
  yourLikes: 'Deine Likes',
  yourFavorites: 'Deine Favoriten',
  allOtherInfo: 'Alle anderen Informationen, die mit deinem Konto zu tun haben',
  yourProfileWillBeHidden:
    'Dein Profi wird für andere Mitglieder verborgen sein. Du wirst keine E-Mails von uns erhalten, bis du dein Konto reaktiviert hast. Tippe auf den Button unten, um dein Konto zu deaktivieren',
  areYouSure: 'Bist du sicher',
  yourAccountWillBeDeact: 'Dein Konto wird deaktiviert',
  yesDeactivateAcc: 'Ja, Konto deaktivieren',
  accountSuccDeact: 'Konto erfolgreich deaktiviert',
  byDeletingYourAccount:
    'Indem du dein Konto löscht, wird die folgende Information dauerhaft entfernt',
  infoUsedToCreate:
    'Information, die zur Erstellung deines Kontos benutzt wurde',
  yourPhotos: 'Deine Fotos',
  yourChatHistory: 'Deine Chat-Geschichte',
  thisActionIsNotReversible: 'Diese Aktion kann nicht reversibel',
  tapTheButtonBellow: 'Tippe auf den Button unten, um dein Konto zu löschen',
  yesDeleteAccount: 'Ja, Konto löschen',
  accountSuccDelete: 'Konto erfolgreich gelöscht',
  byReactivatingYourVip:
    'Indem du dein VIP Mitgliedschafts-Abonnement reaktivierst, wird dir am Ende der aktuellen Verrechnungsperiode die Rechnung gestellt',
  tapTheButtonToReactivateVip:
    'Tippe auf den Button unten, um deine VIP-Mitgliedschaft zu reaktivieren',
  yourMembershipWillExpire: 'Deine Mitgliedschaft endet am',
  yourMembershpWillRenew: 'Deine Mitgliedschaft erneuert sich am',
  yourVipMembershipWillReactivate: 'Deine VIP-Mitgliedschaft wird reaktiviert',
  yesReactivateVip: 'Ja, reaktiviere die VIP-Mitgliedschaft',
  noIveChangedMyMind: 'Nein, ich habe meine Meinung geändert',
  membershipSuccessfullyReactivated: 'Mitgliedschaft erfolgreich reaktiviert',
  membershipSuccessfullyCanceled: 'Mitgliedschaft erfolgreich gekündigt',
  visibilityPreferences: 'Sichtbarkeit-Einstellungen',
  onlyShowMyProfileToPeopleISendMsg:
    'Zeige mein Profil nur Personen, denen ich Nachrichten schicke',
  dataManagement: 'Daten-Management',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'Tippe unten auf den "Daten-Download"-Button, um deine Konto-Daten zu sehen',
  downloadData: 'Daten-Download',
  yesDownload: 'Ja, herunterladen',
  yourDataWillBeDownloaded: 'Deine Daten werden heruntergeladen',
  changePassword: 'Passwort ändern',
  saveChanges: 'Änderungen speichern',
  currentPassword: 'Aktuelles Passwort',
  confirmNewPassword: 'Neues Passwort bestätigen',
  enterNewPassword: 'Neues Passwort eingeben',
  passwordNotMatch: 'Passwort stimmt nicht überein',
  passwordChangedSuccess: 'Passwort erfolgreich geändert',
  registredAs: 'Registriert als:',
  userID: 'Benutzer ID:',
  version: 'Version:',
  // Member
  cancel: 'Löschen',
  reportUser: 'User melden',
  blockUser: 'User blockieren',
  options: 'Optionen',
  startConversation: 'Beginne eine Unterhaltung',
  requestPhotoTap: 'Tippe hier',
  requestPhotoTapTo: 'um sein Foto anzufragen',
  requestPhotoTapToFemale: 'um ihr Foto anzufragen',
  requestPhoto: 'um nach einem Foto zu fragen',
  photoAlreadyRequested: 'Foto bereits angefragt',
  youAlreadyRequestedPhoto:
    'Du hast bereits nach dem Foto dieses Users gefragt',
  photoRequestSuccessfully: 'Foto-Anfrage war erfolgreich',
  tellWhy: 'Sag uns warum',
  inappropriatePhotos: 'Unangebrachte Fotos',
  inappropriateMessages: 'Unangebrachte Nachrichten',
  badOfflineBehavior: 'Schlechtes Offline-Verhalten',
  feelsLikeSpam: 'Sieht nach Spam aus',
  reportChildSafetyConcern: 'Meldung eines Kinderschutzproblems',
  other: 'Andere',
  report: 'Melden',
  reportComment: 'Kommentar melden...',
  blockMember: 'Mitglied blockieren?',
  willNoLongerAppear: 'wird in deiner Treffer-Liste nicht mehr aufscheinen.',
  yesBlock: 'Ja, Mitglied blockieren',
  noCancel: 'Nein, löschen',
  userReportedSuccessfully: 'User erfolgreich gemeldet',
  userBlockedSuccessfully: 'User erfolgreich blockiert',
  addedToFavorites: 'Zu Favoriten hinzugefügt!',
  removedFromFavorites: 'Von Favoriten entfernt!',
  sendAMessage: 'Sende eine Nachricht',
  sendUserAMessage: 'Sende {user} eine Nachricht',
  wellYouveComeThisFar:
    'Du bist so weit gekommen, warum sagst du jetzt nicht einfach etwas',
  chatWith: 'Chatte mit',
  outOfFlirts: 'Keine Flirts mehr',
  untilYouCanSend: 'Bis du wieder einen Flirt senden kannst.',
  wantToMakeSure: 'Willst du sicher gehen',
  seesYou: 'sieht dich?',
  goVipGetFlirts: 'Werde VIP und bekomme {num_of_flirts} Flirts pro Tag!',
  getMoreFlirts: 'Bekomme mehr Flirts',
  noNotThisTime: 'Nicht, nicht im Moment',
  flirtSent: 'Flirt geschick tund geliked',
  memberNotSharedAboutMe:
    'Dieses Mitglied hat seine Über mich-Info nicht geteilt',
  dontWait: 'Warte nicht',
  chooseFlirt: 'Wähle einen Flirt:',
  sendFlirt: 'Sende einen Flirt',
  flirtIsSent: 'Flirt wurde verschickt',
  // Chats
  chats: 'Chats',
  sentMessages: 'Gesendete Nachrichten',
  yourConversations:
    'Deine Unterhaltungen mit anderen Mitgliedern erscheinen hier',
  yourSentMessages:
    'Deine gesendeten Nachrichten an andere Mitglieder erscheinen hier',
  // ChatRoom
  cannotSendMessageUnlessVip:
    "Du kannst keine Chat-Nachrichten schicken, außer du bist ein VIP-User oder die 'Happy Hour' ist aktiv",
  happyHour: 'Happy Hour',
  sendMessagesFree: 'Sende kostenlose Nachrichten',
  endsIn: 'Endet in:',
  happyHourTonightAt: 'Heute Abend um ',
  happyHourTodayAt: 'Heute um ',
  // Contact us
  ContactUs: 'Kontaktiere\u00A0uns',
  ContactUsSupport: 'Kontaktiere uns / Support',
  WhatIsYourEmail: 'Wie lautet deine E-Mail-Adresse?',
  HowCanWeHelpU: 'Wie können wir dir helfen?',
  WriteMsg: 'Nachricht schreiben...',
  SendMsg: 'Nachricht senden',
  EnterMsg: 'Nachricht eingeben.',
  AlertMsgSentSuccessfully: 'Vielen Dank! Nachricht erfolgreich verschickt.',
  ToastMsgSentSuccessfully: 'Nachricht erfolgreich verschickt',
  Subject: 'Betreff',
  subject0: 'Allgemeine Probleme',
  subject1: 'VIP-Mitgliedschaft',
  subject2: 'Betrugs-Meldung',
  subject3: 'Kündigung',
  subject4: 'Konto löschen',
  subject5: 'Andere',
  // Search
  refineSearch: 'Suche verfeinern',
  iamDoneRefining: 'Verfeinerung abgeschlossen',
  showAdvanced: 'Zeige erweiterte Optionen',
  hideAdvanced: 'Erweiterte Optionen verbergen',
  cancelSearch: 'Verfeinerte Suche löschen?',
  youWillLoseYourChanges:
    'Du wirst alle Änderungen deiner Suchkriterien verlieren',
  yesLeavePage: 'Ja, Seite verlassen',
  noContinueRefining: 'Nein, weiter verfeinern',
  zeroMembersFound: 'Gefundene Mitglieder',
  tap: 'Tippen',
  // tapHere: 'Hier tippen',
  // uploadAPhotoHere: 'Hier ein Foto hochladen',
  toDisplayPreviousMembers: 'um vorherige Mitglieder anzuzeigen.',
  toEditCurrentFilters: 'um deine aktuellen Filter zu bearbeiten.',
  resetSearch: 'Suche zurücksetzen',
  tryAgain: 'Erneut versuchen',
  mile: 'Meile',
  miles: 'Meilen',
  noUsers: 'Keine User',
  // Quick Match Button text
  undo: 'Rückgängig',
  pass: 'Weiter',
  like: 'Like',
  profile: 'Profil',
  undoNotAvailable: 'Rückgängig machen nicht verfügbar',
  nothingToUndo: 'Es gibt nichts zum Rückgängig machen.',
  thisIsTheFirstUser: 'Das ist der erste User.',
  undoOnlyLastAction: 'Du kannst nur die letzte Aktion rückgängig machen.',
  dismissAd: 'Ablehnen',
  seeMoreHere: 'Hier mehr sehen',
  tryChangingYourPreferences: 'Versuche, deine Vorlieben zu verändern.',
  errorOnInviteActionTitle: 'Fehler beim Quick Match',
  // It's Match
  itsMutual: 'Es ist beidseitig',
  youAndMemberLikeEachOther: 'Du und {member} mögen einander!',
  seeMoreMatches: 'Betrachte mehr Treffer',
  // My Profile
  edit: 'Bearbeiten',
  aboutMe: 'Über mich',
  youHaveNotSharedAbout: 'Du hast deine Über mich-Info bisher nicht geteilt',
  appearance: 'Erscheinungsbild',
  situation: 'Situation',
  addPhoto: 'Profilfoto hinzufügen',
  // Edit Profile
  editProfile: 'Profil bearbeiten',
  reset: 'Zurücksetzen',
  dob: 'Geburtsdatum',
  youWillLoseYourChangesProfile:
    'Du wirst alle aktuellen Änderungen, die du in deinem Profil gemacht hast, verlieren',
  cancelEdit: 'Bearbeitung des Profils löschen?',
  noContinueEditing: 'Nein, weiter bearbeiten',
  invalidMonth: 'Ungültiger Monat',
  invalidDay: 'Ungültiger Tag',
  invalidAge: 'Du musst zwischen {min} und {max} Jahren sein',
  invalidFebruar: 'Der Februar kann maximal 28 oder 29 Tage haben',
  invalid30Day: 'Dieser Monat kann maximal 30 Tage haben',
  invalid31Day: 'Dieser Monat kann maximal 31 Tage haben',
  invalidLocation:
    'Aufenthaltsort ist ungültig, bitte wähle eine Location aus der Dropdwon-Liste',
  locationUpdated: 'Location erfolgreich aktualisiert',
  setAsMainPhoto: 'Als Hauptfoto einstellen',
  changeAsMainPhoto: 'Als Hauptfoto ändern',
  deletePhoto: 'Foto löschen',
  areSureDeletePhoto:
    'Bist du dir sicher, dass du dieses Foto löschen möchtest?',
  noKeepPhoto: 'Nein, Foto behalten',
  yesDeletePhoto: 'Ja, Foto löschen',
  editPhoto: 'Foto bearbeiten',
  profileUpdated: 'Profil erfolgreich aktualisiert',
  secondaryImageAlertText:
    'Dieses Bild wurden vom Kundenservice als zweite Güte markiert und kann daher nicht als Profilfoto verwendet werden.',
  reviewImageAlertText:
    'Dieses Bild wurde von unserem Kundenservice noch nicht bestätigt, bitte versuche es später.',
  pendingReview: 'Wartende Prüfung',
  // missing location
  locationReq: 'Location-Anfrage',
  pleaseEnterLocation: 'Bitte gib unten deine Location ein.',
  withoutItOther: 'Ohne, können andere Mitglieder',
  cantSee: 'nicht sehen,',
  likeOrMessage: 'liken oder dir schreiben.',
  submit: 'Bestätigen',
  // missing username
  completeYourProfile: 'Vervollständige dein Profil',
  itWillBeUsedOnYourProfileBio: 'Es wird in deiner Profil-Bio verwendet werden',
  userNameDescriptionLetters: '(6-14 Zeichen, A-Z und 0-9)',
  submitUsername: 'Username bestätigen',
  unknownError: 'Unbekannter Fehler aufgetreten',
  confirmUsername: 'Username bestätigen',
  orChooseNewOne: 'oder wähle einen neuen.',
  // missing username and location
  welcomeToSite: 'Willkommen auf ' + config.TITLE,
  yourAccountIsNowActive: 'Dein Konto ist jetzt aktiv!',
  itsGreatToHaveYou:
    'Es ist toll, dich hier als Mitglied unserer Seite willkommen heißen zu dürfen. Wir freuen uns darauf, dir dabei zu helfen, den perfekten\u00A0Partner zu finden.',
  // error
  somethingWentWrong: 'Etwas lief schief',
  networkError: 'Netzwerk-Fehler',
  // invalid Token
  invalidToken: 'Deine Session ist abgelaufen. Bitte später einloggen',
  // rejected Username
  rejectedUsername: 'Abgelehnter Username',
  // missing password
  missingPassword: 'Du bist fast fertig...',
  missingPasswordText: 'Lege unten dein Passwort fest',
  missingPasswordPlaceholder: 'Wenigstens 6 Zeichen',
  submitPassword: 'Passwort festlegen',
  // missing email
  missingEmail: 'Uns fehlt deine E-Mail',
  missingEmailText:
    'Gib unten deine E-Mail-Adresse ein, um Benachrichtigungen über neue Nachrichten, Likes, Treffer und Profilsbesucher zu bekommen.',
  submitEmail: 'E-Mail bestätigen',
  // Move and Scale
  moveAndScale: 'Bewegen und skalieren',
  crop: 'Beschneiden',
  uploadError: 'Fehler Bildupload',
  whoops: 'Uuups',
  itSeemsThatIsTaking:
    'Es sieht so als, als würde es länger als gewöhnlich dauern, um ein Foto hochzuladen. Bitte versuche es erneut.',
  // Missing Photo
  photoRequest: 'Fotoanfrage',
  wait: 'Warten...',
  yourMissingPhoto: 'Dir fehlt ein Foto',
  membersWithoutPhotos: 'Mitglieder ohne Foto bekommen 65% weniger',
  likelyToReceive: 'Likes und Nachrichten',
  submitPhoto: 'Foto bestätigen',
  takePhoto: 'Foto aufnehmen',
  chooseFromLibrary: 'Foto aus Galerie wählen',
  // Missing Gender
  youLookingFor: 'Wonach suchst du',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Du bist fast fertig',
  iWouldLikeToGetSpecOffers:
    'Ich würde gerne spezielle Angebote, tolle Rabatte und monatliche Abverkäufe via Mail erhalten',
  iHaveReadAndAgreeToPP: 'Ich habe sie gelesen und stimme den Bedingungen der',
  ByJoiningTheSiteAgreeTos:
    'Indem du der Seite beitrittst, stimmst du Folgendem zu:',
  optional: 'Optional',
  required: 'Verpflichtend',
  continue: 'Weiter',
  // coreg
  toGetStarted: 'Um zu starten',
  tapHereToGetStarted: 'Tippe hier, um zu beginnen',
  hello: 'Hallo',
  // Upgrade Modal
  membershipStatus: 'Mitgliedschafts-Status',
  upgradeToVipChoosePlan: 'Zu VIP upgraden.',
  wantUnlimitedMessages: 'Möchtest du unbegrenzten Nachrichtenversand?',
  wantToReply: 'Möchtest du %gender% antworten? Werde VIP!',
  getUnlimitedMessages:
    'Bekomme unbegrenzten Nachrichtenversand. Wähle eine Option:',
  needToUndoMistake: 'Du möchest ein Versehen rückgängig machen? Werde VIP!',
  getUnlimitedUndos: 'Rückgängig machen ohne Limit - Wähle eine Option:',
  whoViewedYourProfile: 'Wer hat dein Profil angesehen? Finde es heraus!',
  peopleViewedYourProfile: 'Personen haben dein Profil besucht',
  chooseVipPlanToSeeThem: 'Wähle eine VIP-Option und sehe sie:',
  wantToSeeWhoFavoritedYou: 'Möchtest du sehen, wer dich favorisiert hat?',
  peopleFavoritedYou: 'Personen, die dich favorisiert haben',
  wantToSeeWhoLikesYou: 'Möchtest du sehen, wer dich liked?',
  peopleLikedYou: 'Personen haben dich geliked',
  youAreBasic: 'Du bist ein Basis-Mitglied',
  wantToUnlockPhotos: 'Möchtest du alle Fotos freischalten?',
  wantMoreFlirts: 'Möchtest du 5 Flirts pro Tag?',
  vipMembershipFeatures: 'VIP Premium-Mitgliedschaft Funktionen inkludieren:',
  vipMembershipFeaturesMobile: 'VIP-Mitglieder bekommen:',
  unlimited: 'Unbegrenzten',
  messaging: 'Nachrichtenversand',
  meetSomeoneTonight: 'Jetzt upgraden - Triff heute Abend jemanden!',
  chooseVipPlanBelow: 'Wähle unten einen VIP-Plan:',
  messagingSub: 'Behalte Chats mit deinen Treffern',
  viewedSub: 'Betrachte, wer dein Profil besucht hat',
  likesMeSub: 'Entdecke, wer dein Profil geliked hat',
  unlockPhotosSub: 'Sieh dir alle User-Fotos an',
  favoritedMeSub: 'Finder heraus, wer wirklich an dir interessiert ist',
  moreFlirtsSub: 'Verbesser mit 5 Flirts pro Tag deine Chancen',
  goPrivateSub: 'Kontrolliere, wer dein Profil sieht',
  undoSub: 'Einen Fehler gemacht? Mach deinen Wischer rückgängig!',
  select: 'Wählen',
  vipMembersReceive: 'VIP-MITGLIEDER BEKOMMEN:',
  chooseYourPlan: 'WÄHLE DEINEN PLAN:',
  enterPaymentDetails: 'GIB DEINE ZAHLUNGSDETAILS EIN:',
  creditCard: 'Kreditkarte',
  yourSubscriptionWillRebill:
    'Ihr Abonnement wird am {2} um {1} automatisch auf eine {0} Mitgliedschaft umgerechnet und alle {0} verlängert, bis es gekündigt wird. Sie können jederzeit über Ihre Kontoeinstellungen kündigen.',
  byTappingButtonBelow:
    'Indem du auf den Button unten tippst, stimmst du Folgendem zu',
  andAuthorizeToCharge:
    'und autorisiere uns, deine %CARD_TYPE% jetzt und bei jeder Verlängerung zu belasten.',
  continueToPayPal: 'Weiter zu PayPal, um deinen Kauf abzuschließen.',
  proceedToPayPal: 'Weiter zu PayPal',
  limitedTimeOffer: 'Zeitlich begrenztes Angebot',
  promoHeader: '{date} VIP-Mitgliedschafts-Test für {price}',
  promoHeaderNoTrial: '{price} / {rebill_period} Monat(e)',
  promoSubHeaderText:
    'Das ist ein exklusives einmaliges Angebot für neue Mitglieder',
  promoButtonText: 'Nur {price} - {date} Test',
  promoRebillsText:
    '*Wird jeden {date} für {price} weiter verrechnet, wenn die VIP-Mitgliedschaft nicht vor Ende der Testperiode gekündigt wird*',
  accessToAllPhotos: 'Zugriff auf alle Fotos verfügbar',
  toPremiumUsers: 'nur für Premium-User.',
  unlimitedMessaging: 'Unbegrenzter Nachrichtenversand ist verfügbar',
  upgradeTodayAndSendMessage:
    'Führen Sie noch heute ein Upgrade durch, um Nachrichten zu lesen und zu beantworten, von',
  upgradeTodayAndSeePhotos:
    'Heute upgraden, um auf alle Fotos zuzugreifen, von',
  mostPopular: 'Am beliebtesten',
  notSuitableForCreditCard: 'Keine Möglichkeit, via Kreditkarte zu zahlen?',
  weAreAccepting: 'Wir akzeptieren ',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'Wir haben ein Angebot für dich:',
  discount: 'Rabatt',
  onVipMembership: 'auf eine VIP-Mitgliedschaft!',
  tapHereToSave: 'Tippe hier, um 50% zu sparen!',
  toUnlockFeatures: 'um alle Premium-Funktionen freizuschalten',
  upgrade: 'Upgrade',
  upgradeNow: 'Jetzt upgraden',
  // Invalid Tagline
  invalidTaglineHeadline: 'Beschreibung abgelehnt',
  invalidTaglineTitle:
    'Der Text in deinem "Über mich"-Bereich wurde nicht frei gegeben.',
  invalidTaglineReason: 'Grund: ',
  invalidTaglineButton: 'Beschreibung aktualisieren',
  // Invalid Tagline
  photoRejectedHeadline: 'Foto abgelehnt',
  photoRejectedTitle: 'Es tut uns leid...',
  photoRejectedParagraph:
    'Eines oder mehrere deiner Fotos wurden nicht bestätigt.',
  photoRejectedReason: 'Grund: ',
  photoRejectedButton: 'Reiche ein neues Foto ein',
  viewed: 'Betrachtet',
  myProfile: 'Mein Profil',
  unlock: 'Freischalten',
  allPhotos: 'Alle Fotos',
  undos: 'Rückgängig machen',
  moreFlirts: 'Mehr Flirts',
  goPrivate: 'Privatmodus aktivieren',
  monthFor: 'Monat',
  monthsFor: 'Monate',
  mo: 'Mo',
  month: 'Monat',
  months: 'Monate',
  monthly: 'monatlich',
  billed: 'verrechnet',
  every: 'alle',
  saveUpTo: 'Spare bis zu',
  trialFor: 'Test für',
  day: 'Tag',
  days: 'Tage',
  free: 'kostenlos',
  trialRebillsAt: 'Test wird weiter verrechnet zu',
  per: 'per',
  best: 'Bester',
  value: 'Preis',
  // Checkout
  planSelected: 'Plan ausgewählt',
  paymentOption: 'Zahlungsoptionen',
  billingDetails: 'Rechungsdetails',
  payByCard: 'Zahle mit Karte',
  creditOrDebitCard: 'Zahle mit Kredit- oder Debitkarte',
  payWith: 'Zahle mit',
  pay: 'Pay',
  pal: 'Pal',
  for: 'für',
  promoRebillsAt: 'Promo wird weiter verrechnet am',
  chooseMembershipPlan: 'Wähle unten deinen Mitgliedschaftsplan aus',
  choosePaymentOption: 'Wähle unten deine Zahlungsoptionen',
  enterCardDetails: 'Gib unten deine Kartendetails ein',
  nameOnCard: 'Name auf der Karte',
  enterFullName: 'Hier vollen Namen eingeben',
  creditCardNumber: 'Kreditkarten-Nummer',
  cardNumber: 'Kartennummer',
  enterCardNumberHere: 'Kartennummer hier eingeben',
  expirationDate: 'Ablaufdatum',
  cvv: 'CVV/Sicherheit',
  pleaseEnterCvv: 'Bitte CVV eingeben',
  forYourPrivacyYouAreBilled:
    'Im Sinne deiner Privatsphäre wird deine Karte diskret unter folgendem Namen belastet',
  byCompletingThisTransaction:
    'Indem du diese Transaktion abschließt, bestätigst du, mindestens 18 Jahre alt zu sein und Folgenden zuzustimmen',
  submitAndUpgrade: 'Bestätigen und zum VIP upgraden',
  thisIsSecurePage: 'Das ist eine sichere Seite.',
  dataTransferIsEncrypted:
    'Der Datentransfer ist aus Sicherheitsgründen und zum Schutz verschlüsselt',
  tellUsYourFullName:
    'Teilen Sie uns Ihren vollständigen Namen mit, wie er auf der Karte steht',
  andManyOthers: 'und viele andere',
  youMissedANumber:
    'Es sieht so aus, als hättest du dich bei einer Ziffer vertippt.',
  pleaseEnterYourCreditCard: 'Bitte gib deine Kreditkartennummer ein',
  pleaseEnterValidCreditCard: 'Bitte gib eine gültige Kreditkartennummer ein',
  pleaseEnterMonth: 'Bitte Monat eingeben',
  pleaseEnterValidMonth: 'Bitte gültiges Monat eingeben',
  pleaseEnterYear: 'Bitte Jahr eingeben',
  pleaseEnterValidCvv: 'Bitte gültigen CVV eingeben',
  pleaseAgreeToTos: 'Bitte stimme den Nutzungsbedingungen zu',
  thanksForBeingVip: 'Vielen Dank dafür, dass du ein VIP-Mitglied bist',
  subscriptionUnavailable:
    'Abonnement nicht verfügbar, da du bereits ein VIP-Mitglied bist',
  onTheBackOfCard: 'Auf der Hinterseite deiner Karte',
  findYour: 'kannst du deinen',
  cvvCvc: 'CVV/CVC',
  codeHere: 'Code finden.',
  hurryUp: 'Beeile dich!',
  thisOfferExpires: 'Dieses Angebot endet in:',
  youAreInLuck: 'Du hast Glück!',
  thisPromoGotExtended:
    'Dieses Promo wurde verlängert. Hol es dir schnell, da wir dieses Angebot nun jederzeit beeinden könnten.',
  forYour: 'Im Sinne deiner',
  privacy: 'Privatsphäre',
  youAreBilled: 'wird dein Konto',
  discreetly: 'diskret belastet,',
  as: 'wie folgt',
  specialOffer: 'Besonderes Angebot',
  membershipInfo: 'Mitgliedschafts-Info',
  // Success Upgrade
  successUpgrade: 'Upgrade erfolgreich',
  welcomeToVip: 'Willkommen als VIP!',
  youHaveSuccessfullyUpgraded:
    'Du hast dich erfolgreich hochgestuft und hast nun eine',
  vipPremiumMembership: 'VIP Premium-Mitgliedschaft',
  importantInfo: 'Wiuchtige Information',
  pleasePrintThisPage:
    'Bitte drucken Sie diese Seite aus oder notieren Sie sich die folgenden Informationen. Sie werden diese in Zukunft benötigen, um auf Ihre Mitgliedsinformationen zuzugreifen oder diese zu ändern.',
  yourCreditCardBilled:
    'Deine Kredit-/Debitkarte wird diskret wie folgt belastet',
  yourPayPalCardBilled: 'Dein PayPal-Konto wird diskret wie folgt belastet',
  youWillBeDicreetlyBilled: 'Du wirst diskret wie folgt belastet:',
  membershipPurchased: 'Mitgliedschaft gekauft:',
  billingTerms: 'Abrechnungsbedingungen:',
  vipPremium: 'VIP-Premium',
  total: 'Total',
  vip: 'VIP',
  trial: 'Test',
  yourInfo: 'Deine Information:',
  fullName: 'Voller Name:',
  pleaseContactSupport:
    'Bitte kontaktiere den Support, falls du Fragen zur Rechnung haben sollte',
  billingSupport: 'Rechnungs-Support:',
  billingPhone: 'Rechnungs-Telefon:',
  clickToAccessVip: 'Klicke, um auf VIP-Funktionen zuzugreifen',
  tapToAccessVip: 'Tippe, um auf VIP-Funktionen zuzugreifen',
  thirtyDays: '30 Tage',
  // Process Payment
  processPayment: 'Bitte warte, während wir deine Zahlung verarbeiten...',
  paymentProcessingError: 'Fehler Zahlungsverarbeitung!',
  // Error Component
  serviceUnavailable: 'Service vorübergehend nicht verfügbar',
  pleaseTryLater: 'Bitte später versuchen',
  // Another Client
  isOpenInAnotherWindow:
    'ist in einem anderen Fenster geöffnet. Du kannst dieses Fenster schließen.',
  useInThisWindow: 'In diesem Fenster benutzen',
  // modal alert merging
  greatNews: 'Tolle Neuigkeiten,',
  weAreHappy:
    ' Wir freuen uns zu verkünden, dass ab heute Folgendes aktiv ist: ',
  become: '{old_site} und {new_site} sind nun eine große Seite: {new_site}! ',
  thisMeans:
    ' Das steht für eine größere Community für all unsere Mitglieder, mehr Treffer und eine größere Chance, jemand Besonderen zu treffen.',
  dontWorry:
    'Keine Sorge, für dich als unser Mitglied, ändert sich nichts. Deine Login- und Profil-Information sowie Geschichte wurde automatisch transferiert, damit du dort weiter machen kannst, wo du letztes Mal aufgehört hast. ',
  // ads
  ad: 'Anzeige',
  sponsored: 'GESPONSERT',
  findNiche:
    'Finde ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche:
    'Triff' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Triff' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Single ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Finde ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Date ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romanze',
  adsRandomTextLonelyNiche:
    'Einsam' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Liebe',
  adsRandomTextWhantNiche:
    'Möchte' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Dates',
  adsRandomTextMoreNiche:
    'Mehr' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'Suche' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Jetzt?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Singles',
  // niche gender names
  genderTsTvTg: 'TS/TV/TG',
  genderXdresser: 'Cross\u00ADdresser',
  genderCouple: 'Paar',
  genderDom: 'Domme',
  genderFem: 'Femdom',
  genderBiCouple: 'Bi-Paar',
  genderSugarMale: 'Sugar Baby männlich',
  genderSugarBaby: 'Sugar Baby',
  genderHotWife: 'Heiße Ehefrau/\n\u00ADPaar',
  genderMan: 'Mann',
  lookingFor: 'suche nach',
  genderMilf: 'MILF',
  // onboarding
  moreInformation:
    'Gib uns ein bisschen mehr Information über dich, damit wir Singles finden können, die zu dir passen',
  howTallAreYou: 'Wie groß bist du?',
  UseSliderHeight: 'Benutze den Schieberegler, um deine Größe auszuwählen',
  WhatIsYourEthnicity: 'Welche Volkszugehörigkeit hast du?',
  specifyYourBodyType: 'Bitte geben Sie Ihren Körpertyp an',
  whatYouLookingFor: 'Erzähle uns von deinem perfekten Partner',
  idealMatchesAge: 'Wie alt ist dein idealer Partner',
  howFarAway:
    'Wie weit würdest du reisen, um deinen perfekten Partner zu treffen?',
  useSliderDistance: 'Benutze den Schieberegler um die Entferung auszuwählen',
  toHaveYourProfile: 'Erzähle anderen Mitgliedern über dich...',
  writeSomethingAboutYourself:
    'Schreibe etwas Interessantes über dich selbst, etwas, das dich selbst am besten beschreibt',
  uploadAPhoto: 'Lade ein Foto hoch',
  thisIsImportant: 'Das ist das wichtigste Feature von deinem Profil!',
  youOnlyHave:
    'Du hast nur eine Chance, einen ersten Eindruck zu hinterlassen.',
  tipPhoto:
    'Tipp: Fotos sollten aktuell sein, nur dich zeigen und deine besten Qualitäten hervorheben, um bessere Resultate zu erzielen!',
  iUploadLater: 'Ich lade später ein Foto hoch...',
  congratulations: 'Gratulation...',
  yourProfileUpdated:
    'Dein Profil wurde aktualisiert und du bist in deiner Suche nach dem perfekten Partner nun einen Schritt weiter.',
  specialOfferNewMembers:
    'Als besonderes Angebot für neue Mitglieder geben wir dir 25% Rabatt auf unsere regulären Mitgliedschafts-Preise.',
  get25OffNow: 'Bekomme jetzt 25% Rabatt!',
  youWillBeRedirected: 'du wirst zur Upgrade-Seite weitergeleitet in',
  seconds: 'Sekunden',
  aNewMember: 'Als neues Mitglied qualifizierst du dich für ein',
  get: 'Bekomme',
  initialOff: '25% Rabatt',
  selectedMembership: 'auf deine gewählte Mitgliedschaft',
  selectYourMembership: 'Wähle deine Mitgliedschaftsoption',
  newPrice: 'Neuer Preis',
  oldPrice: 'Alter Preis',
  iDontWantToPayLess: 'Nein danke, ich möchte nicht weniger zahlen.',
  addPhotoOnboarding: 'Foto hinzufügen',
  uploadAnotherPhoto: 'Ein weiteres Foto hochladen',
  finish: 'Beenden',
  ifYourDoneUploadingPhotos: 'Wenn du mit dem Fotoupload fertig bist',
  // california
  CCPATitle: 'Meine persönlichen Informationen nicht verkaufen',
  CCPAPersonal: 'Meine persönlichen Informationen',
  youHaveAlreadyOptedOut: 'Du hast dich bereits abgemeldet.',
  // TransactionProgress
  transactionProgress: 'Transaktionsfortschritt',
  checkingSpecialOffers: 'Prüfe besondere angebote...',
  initializingTransaction: 'Transaktion initialisieren...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Gratulation!',
  youAreQualified: 'Du hast dich für ein besonderes Angebot qualifiziert!',
  toAcceptThisOffer: 'Tippe unten, um dieses Angebot anzunehmen:',
  noThanksIDontWant: 'Nein danke, ich möchte nicht weniger bezahlen.',
  forYourConvenience:
    'Der Einfachheit halber, stellen wir dir wieder eine Rechnung, ',
  on: 'am',
  andEvery: 'und alle',
  daysThereafter: 'Tage danach, bis zur Kündigung.',
  off: 'Aus',
  yourSelectedMembership: 'deine ausgewählte Mitgliedschaft.',
  // Transaction Declined
  transactionDeclined: 'Transaktion abgelehnt',
  yourCreditCardWasNotApproved:
    'Deine Kreditkarte wurde für unser spezielles Mitgliedschaftsangebot nicht bestätigt.',
  butWait: 'aber WARTE... hier ist noch ein besonderes Angebot',
  tryA: 'Teste ein',
  forOnly: 'für nur',
  acceptOffer: 'Angebot annehmen',
  membership: 'Mitgliedschaft',
  // Measure System
  measureSystem: 'Maßsystem',
  imperial: 'Britisch',
  metric: 'Metrisch',
  // kink cam banner
  viewNow: 'Jetzt ansehen',
  youGotAFree: 'Du hast ein kostenloses',
  // receipt page
  bonusMembership: 'Bonus-Mitgliedschaft',
  membersLoginArea: 'Mitglieder Login-Bereich',
  // language
  language: 'Sprache',
  // OneClick
  signInFromReferal:
    'Melde dich mit deinem Profil von der bezugnehmenden Seite an',
  siteWouldLikeToAccess:
    config.TITLE +
    ' möchte gerne Zugriff auf die folgenden Informationen, um sich auf dieser Seite zu registrieren:',
  permissionsToAccess:
    'Name, E-Mail, Geburtsdatum, Location und Basis Dating Profil-Details',
  iConsentToDetailsAndRegister:
    'Ich stimme zu, dass diese Details benutzt werden, um mein Profil zu registrieren und ich bestätige, dass ich Folgendem zustimme ',
  allow: 'Erlauben',
  byClickingAllow:
    'In dem du auf ERLAUBEN klickst, stimmst du zu, dass diese Details von ' +
    config.TITLE +
    ' genutzt werden, um dich auf der Datingseite anzumelden und dass du den Nutzungsbedingungen unten zustimmst. Alternativ kannst du Folgendes nutzen ',
  standardRegistrationForm: 'Standard Registrierungs-Formular',
  // SpecialOffer2x
  getFreeMembership: 'Holen Sie sich eine KOSTENLOSE Mitgliedschaft bei {0}',
  doubleYourChances: 'Verdoppeln Sie Ihre Chancen, jemanden zu treffen',
  weHavePartnered:
    'Wir haben uns mit {0} zusammengetan, um die Chancen unserer Mitglieder zu erhöhen, eine Übereinstimmung zu finden. Sobald Sie auf die Schaltfläche oben klicken, erstellen wir automatisch ein 100 % KOSTENLOSES PROFIL bei {0} und leiten Sie zum Mitgliederbereich weiter, damit Sie in der Datenbank nach potenziellen Übereinstimmungen suchen können.',
  congratulationsYouGotFree:
    'Herzlichen Glückwunsch, Sie haben eine KOSTENLOSE Mitgliedschaft bei {site_name} erhalten.',
  toGetLoggedInto: ' um sich auf der Website einzuloggen.',
  // RefundCreditCard
  refundCreditCard: 'Rückerstattung mit neuer Kreditkarte',
  refundCreditCardSuccess:
    'Ihr Erstattungsantrag wurde erfolgreich übermittelt.',
  // Nearby Connect
  nearbyConnect: 'Connect in der Nähe',
  nearbyDecline:
    'Nein danke, ich möchte es jetzt nicht senden, ich werde es später tun.',
  introduceMyself: 'Mich vorstellen',
  distance: 'Distanz',
  anyDistance: 'Jede Distanz',
  message: 'Botschaft',
  sentByNearbyConnect: 'Gesendet von Connect in der Nähe',
  typeYourMessageHere: 'Schreiben Sie ihre Nachricht hier',
  sendThisToMyNewMatches:
    'Senden Sie dies auch an alle neuen Spiele, wenn sie beitreten',
  successNearbyConnect: 'Sie haben Nearby Connect erfolgreich eingerichtet',
  nearbyConnectTitle:
    'Nehmen Sie sofort Kontakt mit Hunderten von Mitgliedern auf! Nur Benutzer, die Ihrem Profil entsprechen, erhalten diese Nachrichten. Geben Sie unten Ihre Nachricht ein, um loszulegen:',
  nearbyConnectAlert:
    'Nearby Connect-Nachrichten sind einzigartige Nachrichten von anderen echten Mitgliedern, die perfekt zu Ihnen passen könnten. Diese Nachrichten werden automatisch nur an Benutzer gesendet, die diesem Benutzerprofil entsprechen.',
  nearbyUnavailable:
    'Tut mir leid, die NearbyConnect-Funktion ist derzeit nicht verfügbar. Diese Funktion kann einmal alle 30 Tage verwendet werden. Danke für Ihr Verständnis.',
  nearbyFeatureUsed:
    'Sie haben die NearbyConnect-Funktion für {date} verwendet.',
  toKeepNearbyFree:
    'Um NearbyConnect kostenlos zu halten, beschränken wir es auf nur eine Einführung alle 30 Tage.',
  ifYouLikeToBeIntroduced:
    'Wenn Sie mehr Mitgliedern vorgestellt werden möchten, zahlen Sie {date}.',
  nearbyConnectValentineTitle: 'Valentinstag-Special',
  nearbyConnectValentineText1:
    'Der Valentinstag rückt näher. Für eine begrenzte Zeit können Sie eine senden ',
  nearbyConnectValentineText2: 'KOSTENLOSE Einführungsnachricht ',
  nearbyConnectValentineText3:
    'an Hunderte von Benutzern, die Ihren Vorlieben entsprechen. Geben Sie einfach unten Ihre Nachricht ein, um loszulegen:',
  // subscription status
  subscriptionStatus: 'Abonnementstatus',
  subscritpionStatusManageLink1:
    'Herzlichen Glückwunsch! Sie sind ein VIP-Mitglied. Bitte besuche ',
  subscritpionStatusManageLink2: 'um Ihr Abonnement zu verwalten.',
  subscriptionUpgradeLink1: 'Du bist ein Basismitglied. ',
  subscriptionUpgradeLink2: 'Upgrade jetzt auf VIP!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Nearby Connect verwalten',
  sendNewNearbyConnectMessage: 'Neue NearbyConnect-Nachricht senden',
  activeUntil: 'Aktiv bis',
  sendToNewJoins: 'An neue Mitglieder senden',
  update: 'Aktualisieren',
  disable: 'Deaktivieren',
  nearbyConnectUpdated: 'Nearby Connect wurde erfolgreich aktualisiert',
  nearbyConnectWillBeAvailable:
    'Nearby Connect steht Ihnen beim nächsten Mal zur Verfügung ',
  canChangeMessageOn: 'Kann die Nachricht ändern',
  getInTouchWith:
    'Nehmen Sie sofort Kontakt mit Hunderten von Mitgliedern auf! Nur Benutzer, die Ihrem Profil entsprechen, erhalten diese Nachrichten.',
  // Cookie Consent
  cookieConsentText:
    'Die Seite verwendet Cookies. Durch die weitere Navigation auf der Website stimmen Sie der Verwendung von Cookies ausdrücklich zu.',
  cookieConsentDetailsLinkText: 'Einzelheiten',
  cookieConsentButtonText: 'Ich verstehe',
  cookieConsentDeclineButtonText: 'schließen',

  cookieTitle: 'Diese Seite verwendet Cookies',
  cookieSubTitle:
    'Wir verwenden Cookies und andere Tracking-Technologien, um Ihr Surferlebnis auf unserer Website zu verbessern, Ihnen personalisierte Inhalte und zielgerichtete Werbung anzuzeigen, den Verkehr auf unserer Website zu analysieren und zu verstehen, woher unsere Besucher kommen.',
  cookieAcceptAllCookies: 'Akzeptiere alle',
  cookieDeclineAllCookies: 'Alle ablehnen',
  cookieManagePreferences: 'Ändern Sie meine Einstellungen',
  cookieClosePreferences: 'Schließen Sie die Einstellungen',
  cookieNecessaryTitle: 'Notwendig',
  cookieNecessaryDescription:
    'Diese Cookies sind unerlässlich, um Ihnen die über unsere Website verfügbaren Dienste bereitzustellen und Ihnen die Nutzung bestimmter Funktionen unserer Website zu ermöglichen. Ohne diese Cookies können wir Ihnen bestimmte Dienste auf unserer Website nicht anbieten.',
  cookieActiveText: 'Aktiv',
  cookieAlwaysActiveText: 'Immer aktiv',
  cookieInactiveText: 'Inaktiv',
  cookieFunctionallityTitle: 'Funktionalität',
  cookieFunctionallityDescription:
    'Diese Cookies werden verwendet, um Ihnen ein persönlicheres Erlebnis auf unserer Website zu bieten und um Entscheidungen zu speichern, die Sie bei der Nutzung unserer Website treffen. Beispielsweise können wir Funktionscookies verwenden, um Ihre Spracheinstellungen oder Ihre Anmeldedaten zu speichern.',
  cookieAnalyticsTitle: 'Analytik',
  cookieAnalyticsDescription:
    'Diese Cookies werden verwendet, um Informationen zu sammeln, um den Verkehr auf unserer Website und die Art und Weise, wie Besucher unsere Website nutzen, zu analysieren. Diese Cookies können beispielsweise erfassen, wie lange Sie auf der Website verbringen oder welche Seiten Sie besuchen. Dies hilft uns zu verstehen, wie wir unsere Website für Sie verbessern können. Die durch diese Tracking- und Performance-Cookies gesammelten Informationen identifizieren keinen einzelnen Besucher.',
  cookieMarketingTitle: 'Marketing',
  cookieMarketingDescription:
    'Diese Cookies werden verwendet, um Ihnen Werbung anzuzeigen, die aufgrund Ihres Surfverhaltens wahrscheinlich für Sie von Interesse ist. Diese von unseren Inhalts- und/oder Werbeanbietern bereitgestellten Cookies können Informationen, die sie auf unserer Website gesammelt haben, mit anderen Informationen kombinieren, die sie unabhängig im Zusammenhang mit den Aktivitäten Ihres Webbrowsers in ihrem Netzwerk von Websites gesammelt haben. Wenn Sie diese Targeting- oder Werbe-Cookies entfernen oder deaktivieren, werden Ihnen weiterhin Werbeanzeigen angezeigt, diese sind jedoch möglicherweise nicht für Sie relevant.',
  cookieOtherTitle: 'Andere',
  cookieOtherDescription: 'Einige andere Cookies',
  cookieSavePreferences: 'Einstellungen speichern und schließen',
  cookiePreferencesTitle: 'Wählen Sie Ihre Präferenzen',
  manageCookies: 'Cookie-Einstellungen',
  cookiesViewDetails: 'Se detaljer',
  cookiesProviders: 'Cookies-Anbieter',
  cookiesYahoo:
    'Wird von Yahoo zur Personalisierung von Inhalten und Werbung verwendet.',
  cookiesGoogleDetectSpam:
    'Wird zur Erkennung von Spam, Betrug und Missbrauch verwendet.',
  cookiesGoogleAds:
    'Wird verwendet, um Google-Anzeigen basierend auf kürzlich durchgeführten Suchanfragen und Interaktionen zu personalisieren.',
  years: 'Jahre',
  year: 'Jahr',
  cookiesGoogleAdDelivery:
    'Wird verwendet, um Anzeigenauslieferung oder Retargeting bereitzustellen.',
  cookiesGoogleUseOurSite:
    'Cookie zum Sammeln von Informationen darüber, wie Besucher unsere Site nutzen.',
  cookiesGoogleDistinguishUsers:
    'Wird verwendet, um Benutzer zu unterscheiden.',
  cookiesGoogleCrossSite:
    'Dieses Cookie wird verwendet, um zu verhindern, dass der Browser dieses Cookie zusammen mit Cross-Site-Anfragen sendet.',
  cookiesGoogleUniqueIdTracking:
    'Diese Cookies verwenden eine eindeutige Kennung für Trackingzwecke.',
  cookiesGoogleProtectData:
    'Sicherheitscookie zum Schutz der Benutzerdaten vor unbefugtem Zugriff.',
  cookiesGoogleTrackConversions:
    'Wird zum Speichern und Verfolgen von Konvertierungen verwendet.',
  cookiesBingAds:
    'Dieses Cookie ermöglicht es, Besuchern relevante Werbung zu präsentieren.',
  cookiesBingTracking:
    'Von Bing Ads verwendetes Microsoft User Identifier-Tracking-Cookie.',
  cookiesBingTrackingAdvertising:
    'Dies ist ein Tracking-Cookie, das von Microsoft Bing-Werbung verwendet wird, um es uns zu ermöglichen, mit einem Besucher in Kontakt zu treten, der zuvor unsere Website besucht hat.',
  cookiesBingClarityID:
    'Die Clarity-Benutzer-ID und -Einstellungen bleiben erhalten. Sie sind für diese Site eindeutig und werden derselben Benutzer-ID zugeordnet.',
  cookiesBingClarityMultiple:
    'Verbindet mehrere Seitenaufrufe eines Benutzers zu einer einzigen Clarity-Sitzungsaufzeichnung.',
  cookiesFacebookTracking:
    'Wird zum Speichern und Verfolgen von Besuchen auf verschiedenen Websites verwendet.',
  cookiesFacebookUniqueId:
    'Wird verwendet, um eine eindeutige Kennung für Ihren Browser zu speichern, die uns unter anderem dabei hilft, Sie vor Betrug zu schützen.',
  cookiesFacebookDevicePixelRatio:
    'Wird verwendet, um das Gerätepixelverhältnis Ihres Bildschirms aufzuzeichnen und festzustellen, ob Sie den Hochkontrastmodus aktiviert haben oder nicht, damit wir unsere Websites optimal darstellen können.',
  cookiesFacebookMarketing:
    'Wird verwendet, um Anzeigenauslieferung oder Retargeting bereitzustellen.',
  cookiesGoogleDoubleClick:
    'Wird von Google DoubleClick verwendet, um die Aktionen des Nutzers auf der Webseite nach dem Anzeigen oder Klicken auf eine der Anzeigen des Werbetreibenden zu registrieren und zu melden, mit dem Ziel, die Wirksamkeit einer Anzeige zu messen und dem Nutzer gezielte Anzeigen zu präsentieren.',
  cookiesBingRefreshMuid: 'Gibt an, ob MUID aktualisiert werden soll.',
  cookiesRomanceGuard:
    'Wird zur Erkennung von Betrug, Spam und Malware verwendet.',
  cookiesTaboolaUniqueId:
    'Weist eine eindeutige, partitionierte Benutzer-ID zu, die Taboola für Zuordnungs- und Berichtszwecke verwendet und um Empfehlungen basierend auf Interaktionen mit einem Werbetreibenden oder Publisher auf diesen bestimmten Benutzer zuzuschneiden.',
  cookiesSnapchatId: 'Wird zur Identifizierung eines Besuchers verwendet.',
  cookiesSnapchatTrackId:
    'Legt eine eindeutige ID für den Besucher fest, die es Drittanbieter-Werbetreibenden ermöglicht, den Besucher mit relevanter Werbung anzusprechen. Dieser Pairing-Dienst wird von Drittanbieter-Werbe-Hubs bereitgestellt und ermöglicht Werbetreibenden Echtzeitgebote.',
  cookiesSnapchatPixelId:
    'Wird verwendet, um zu bestimmen, ob in einem Snap Ads Pixel ein Drittanbieter-Tag aufgerufen wird.',
  cookiesVWOVisits: 'Wird zum Speichern eindeutiger Besuche verwendet.',
  cookiesVWOTest:
    'Wird verwendet, um zu lesen, ob Cookies platziert werden können.',
  cookiesVWOSafari:
    'Dieses Cookie ist eine Sammlung aller Cookies. Es wird derzeit nur für den Safari-Browser erstellt. In Zukunft wird es alle VWO-Cookies ersetzen. HINWEIS: Das tatsächliche Ablaufdatum dieses Cookies ist irrelevant, da es das Ablaufdatum der darin gesetzten Cookies speichert und diese immer wieder ablaufen lässt.',
  cookiesVWODS:
    'Dieses Cookie speichert dauerhafte Daten auf Besucherebene für VWO Insights.',
  cookiesVWOExpiration: 'Hängt von der Aufbewahrungsdauer des Kontos ab.',
  cookiesVWOUniqueId:
    'Dieses Cookie generiert eine eindeutige ID für jeden Besucher und wird für die Berichtssegmentierungsfunktion in VWO verwendet. Es ermöglicht auch eine verfeinerte Anzeige von Daten.',
  cookiesVWOUniqueVisits:
    'Dieses Cookie berechnet den eindeutigen Besucherverkehr auf einer Website.',
  cookiesAppsFlyer:
    'Wir verwenden diesen Dienst, um Benutzergeräte wie iOS-iPhones oder Android-Telefone zu erkennen und den Benutzern ein Banner anzuzeigen, das sie darüber informiert, ob sie native Anwendungen aus dem iStore oder Google Play Store installieren möchten.',
  cookiesTikTok:
    'Um die Leistung Ihrer Werbekampagnen zu messen und zu verbessern und um das Benutzererlebnis (einschließlich Anzeigen) auf TikTok zu personalisieren.',
  cookiesRaygun:
    'Raygun bietet Softwareteams Fehler-, Absturz- und Leistungsüberwachung.',
  name: 'Name',
  description: 'Beschreibung',
  duration: 'Dauer',
  url: 'URL',
  domain: 'Domain',

  // email verification
  welcome: 'Willkommen',
  emailConfirmationTitle:
    'Bestätige deine E-Mail, um in Verbindung zu bleiben!',
  emailConfirmationDesc:
    'Deine E-Mail ist noch nicht bestätigt, daher erhältst du derzeit keine E-Mails oder Nachrichten!',
  weRecomend:
    'Wir empfehlen dir, auf die Schaltfläche zu klicken, um den Link erneut zu senden, und dann deine E-Mails zu überprüfen.',
  resendConfirmation: 'BESTÄTIGUNGSMAIL ERNEUT SENDEN',
  ifForAnyReason:
    'Falls du aus irgendeinem Grund deine E-Mail-Adresse ändern möchtest, ',
  dontSeeIt: 'Siehst du es nicht?',
  andWeWillResend:
    'und wir werden die E-Mail sofort erneut senden, damit sie leicht zu finden ist!',
  checkSpamFolder: 'Überprüfe den Spam-Ordner',
  ifYouDoNotSeeYourMessage:
    'Wenn du deine Nachricht nicht im Posteingang siehst, überprüfe den Spam-Ordner.',
  thenSelect: 'Wähle dann die Nachricht aus und markiere sie als KEIN SPAM.',
  needHelp: 'Brauchen Sie Hilfe? ',
  ClickHereForMoreInfo: 'Klicke hier für weitere Infos',
  addUsToYouContacts: 'Fügen sie uns zu ihrer Kontaktliste Hinzu',
  beSureToAdd: 'Fügen Sie unbedingt hinzu',
  notifyEmail: 'notify@nearbynotifications.com',
  toYourAddressBook:
    'zu Ihrem Adressbuch/Ihrer Kontaktliste, damit Ihre Nachrichten und Flirts in Ihrem Posteingang landen.',
  copiedToClipboard: 'In die Zwischenablage kopiert',
  cantWait:
    'Wir können es kaum erwarten, dir zu helfen, deinen perfekten Partner zu finden. Wir haben Tausende von Mitgliedern, die darauf warten, dich zu treffen...',
  seeYou: 'Wir sehen uns auf der anderen Seite!',
  emailConfirmationDecline:
    'Nein danke, ich möchte es jetzt nicht senden, ich werde es später tun.',
  emailConfirmationToast:
    'Bestätigungslink erfolgreich gesendet. Bitte überprüfe deine E-Mails.',

  // addUsToContactsInfo
  addUsToYouContactsList:
    'Füge ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' zu deiner Kontaktliste hinzu, um zu vermeiden, ',
  missingAnyMessage: 'NACHRICHTEN ZU VERPASSEN!',
  contactsInfoDetails:
    'Füge ' +
    config.DOMAIN.replace(/https?:\/\//, '').toUpperCase() +
    ' zu deinem Adressbuch oder deiner Kontaktliste hinzu, damit du keine Nachrichten oder Flirts verpasst.',
  openMessageStep:
    'Öffne eine Nachricht von dem Absender, den du in Gmail als Kontakt speichern möchtest.',
  hoverCursorStep:
    'Bewege den Cursor über den Namen des Absenders oben in der E-Mail.',
  selectAddToContactsStep: 'Wähle im Popup-Menü "Zu Kontakten hinzufügen".',
  resendConfirmationLinkText:
    'Klicke hier, um den Bestätigungslink erneut zu senden',
  toMakeItEasier: 'damit es einfacher zu finden ist in deinem Postfach!',
  checkGmailInbox: 'ÜBERPRÜFE DEINEN GMAIL-POSTEINGANG',

  // checkSpamFolder
  beSure: 'Stelle sicher, dass du den',
  spamFolder: 'Spam-Ordner',
  ifYouDoNotSeeMessage:
    'überprüfst, wenn du unsere Nachricht nicht im Posteingang siehst!',
  spamFolderDetails:
    'Wenn du feststellst, dass unsere Nachricht fälschlicherweise als Spam eingestuft wurde, kannst du die Markierung entfernen.',
  unmarkingAMessage:
    'Das Entfernen der Markierung verschiebt die Nachricht automatisch in deinen Posteingang.',
  openSpamFolderStep: 'Klicke auf Spam auf der linken Seite jeder Seite.',
  selectMessageStep: 'Wähle die Nachricht aus.',
  markAsNotSpamStep: "Klicken Sie auf 'Kein Spam' oben auf der Seite.",

  // change email
  changeEmail: 'E-Mail ändern!',
  newEmailAddress: 'Neue E-Mail-Adresse',
  currentEmailAddress: 'Aktuelle E-Mail-Adresse',

  // cancel web subscription
  cancelVipMembership: 'VIP-Mitgliedschaft kündigen',
  yesCancelVip: 'Ja, VIP-Mitgliedschaft kündigen',
  noKeepVip: 'Nein, VIP-Mitgliedschaft behalten',
  doYouWantToGiveUpVip:
    'Möchten Sie wirklich auf all diese großartigen Funktionen verzichten?',
  cancelSubscriptionSuccess: 'Abonnement erfolgreich gekündigt.',
  resubscribeVip: 'VIP-Abonnement erneuern',
  weWillNotRenewYourSubscription:
    'Ihr Abonnement ist derzeit aktiv, jedoch haben Sie es gekündigt. Sobald Ihr Abonnement abläuft, wird es nicht erneuert, und Sie verlieren den Zugriff auf Premium-Funktionen. Sie können Ihr Abonnement jederzeit vor Ablauf erneuern, um Ihre Vorteile weiterhin zu genießen.',
};



// WEBPACK FOOTER //
// ./src/assets/localization/de.js